import moment from 'moment'

import { IReceipt } from '@/types/receipt'

export const parseReceiptFromResponse = (receipt: IReceipt): IReceipt => {
  receipt.items.forEach(item => {
    if (item.name === null || item.name.length === 0) {
      item.name = item.ocr
    }
  })
  if (receipt.dateTime !== null && typeof receipt.dateTime === 'string') {
    receipt.dateTime = moment(receipt.dateTime).toDate()
  }
  return receipt
}
